<template>
  <el-dialog
      :title="getTitle()"
      :visible.sync="notificationData.show"
      width="30%"
      :before-close="cancel">
    <span v-html="notificationData.message"></span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="agree">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: "Notification",
    data: function () {
      return {

      }
    },
    methods: {
      agree: function () {
        this.$store.commit('closeNotification')
        if(this.$route.name==='category-management-id'){
          if(this.$route.query.file_id){
            this.$router.push('/file-management')
          }else{
            this.$router.push('/category-management')
          }
        }
      },
      cancel: function () {
        this.$store.commit('closeNotification')
      },
      getTitle: function () {
        return this.notificationData.type === 'error' ? this.$t('common.error') : this.$t('common.success')
      }
    },
    computed: {
      ...mapState(['notificationData'])
    }
  }
</script>

<style lang="scss">

</style>
